import API from "../../services/api";

/**
 * Employee-level statutory API client (UAN, PF#, PT#, LWF#, PAN, Aadhaar).
 *
 * Aadhaar is never sent back from the server as a raw number — only ``aadhaar_last4``
 * survives in the response DTO.
 */

export function getEmployeeStatutory(employeeId) {
  return API.get(`/statutory/employees/${employeeId}`).then((r) => r.data ?? null);
}

export function createEmployeeStatutory(employeeId, payload) {
  return API.post(`/statutory/employees/${employeeId}`, payload).then(
    (r) => r.data
  );
}

export function upsertEmployeeStatutory(employeeId, payload) {
  return API.put(`/statutory/employees/${employeeId}`, payload).then(
    (r) => r.data
  );
}

/* ─── On-blur validators ──────────────────────────────────────────────────── */
export function validateUan(uan, { checkUniqueness = true } = {}) {
  return API.post("/statutory/validate/uan", {
    uan_number: uan,
    check_uniqueness: checkUniqueness,
  }).then((r) => r.data);
}

export function validatePan(pan, { checkUniqueness = true } = {}) {
  return API.post("/statutory/validate/pan", {
    pan,
    check_uniqueness: checkUniqueness,
  }).then((r) => r.data);
}

export function validateAadhaar(aadhaar, { checkUniqueness = true } = {}) {
  return API.post("/statutory/validate/aadhaar", {
    aadhaar,
    check_uniqueness: checkUniqueness,
  }).then((r) => r.data);
}
